export const loadMonaco = () => import(/* webpackChunkName: "monaco-editor" */ 'monaco-editor');
